import { triggerSync } from '../api/tickets';

/**
 * Shared client-side sync cooldown so the Tickets sync modal and the Settings
 * Data Sync section don't let a user hammer the sync trigger from two places.
 */
const SYNC_COOLDOWN_MS = 2 * 60 * 1000;
let lastSyncTriggeredAt: number | null = null;

export function isSyncInProgress(): boolean {
  return lastSyncTriggeredAt != null && Date.now() - lastSyncTriggeredAt < SYNC_COOLDOWN_MS;
}

export async function triggerSyncWithCooldown(fullSync: boolean): Promise<void> {
  await triggerSync(fullSync);
  lastSyncTriggeredAt = Date.now();
}

export { SYNC_COOLDOWN_MS };
